module.exports = __webpack_public_path__ + "static/media/summary_arrow.9fdf30cd.svg";